import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { DtoSetting, IDtoSetting } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoSettingEntityDataService } from '../interfaces/dto.setting.entty.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoSettingEntityDataService extends EntityDataService<IDtoSetting> implements IDtoSettingEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getSettingsForMandator$(mandatorId: number): Observable<IDtoSetting[]> {
    return this.httpGet(`/api/web/settings/mandator/${mandatorId}`)
      .pipe(map((entities: IDtoSetting[]) => {
        const result: IDtoSetting[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getSettingsForMandatorAsync(mandatorId: number): Promise<IDtoSetting[]> {
    return (await this.getSettingsForMandator$(mandatorId).toPromise());
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('/api/web/settings', this.configurationService.configData.urlApi);
  }

  protected override createEntityFromJson(json: any): IDtoSetting {
    const result: IDtoSetting = (UtilsJson.deserialize(json, DtoSetting) as IDtoSetting);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    this._urls.add('get.by.mandator', UtilsString.stringFormat('{0}://{1}:{2}/{3}/mandator/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}');

    return this._urls;
  }

}
